export default function (...args: any): string {
	const key: string = args[0];
	args = (args as Array<any>).slice(1);
	return key.replace(/{(\d+)}/g, function (match: any, number: any) {
		return typeof args[number] != 'undefined' ? args[number] : match;
	});
}
